export const FROM_VALUE = 'FROM_VALUE'
export const CUSTOM = 'CUSTOM'

export const control_options = [{
    label: 'Как у значения',
    value: FROM_VALUE,
}, {
    label: 'Указать',
    value: CUSTOM,
},]